import { useEffect } from "react";
import { connect } from "react-redux";
import { fetchBasket } from "actions/basket";
import { setFalseThankYouPage } from "actions/checkout";

import $R from "plugins/tfs/platformConfigs/integrationMaps/routes";

let _content = null;

const ThankYou = (props) => {
  const { fetchBasket, setFalseThankYouPage, history } = props;

  useEffect(() => {
    fetchBasket();

    return () => setFalseThankYouPage();
  }, []);

  const onGoBackHomeButtonClick = (e) => {
    e.preventDefault();
    history.push($R.MAIN_HOME.path);
  };

  return (
    _content &&
    _content({
      props,
      onGoBackHomeButtonClick,
    })
  );
};

const mapStateToProps = (state) => ({
  orderNumber: state.checkout.context.order_number,
});

const mapDispatchToProps = {
  fetchBasket,
  setFalseThankYouPage,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(ThankYou);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/checkout/thankyou/index.js